export enum machineStatus {
  installed,
  purchased,
  shipped,
  unknown,
  obsolete,
}

export type Machine = {
  id?: number;
  serialNumber?: string;
  manufacturer?: string;
  item?: string;
  assetRecordType?: string;
  project?: string;
  description?: string;
  customerSiteCode?: string;
  customerSiteName?: string;
  customerCode?: string;
  businessUnit?: string;
  installationDate?: string;
  warrantyPeriod?: string;
  status?: machineStatus;
  hasImage?: boolean;
  modelImage?: string;
  hasDocument?: boolean;
  hasMaintList?: boolean;
  hasEmergList?: boolean;
  naturalKey?: string;
};



export interface LineMachine {
  linedesc: string
  lineid: number
  machinedesc: string
  machinehasbom: string
  machineid: number
}
